// Vuex Agents module actions
import { API } from '@/config';

import {} from './mutations-types';

export default {
  async update(context, params) {
    try {
      await API.post('/access/update-email', params);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject();
    }
  },
};
